import {Injectable, inject} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';

export interface IProjectDetailsDraft {
    [key: string]: unknown;
    projectInfo?: Record<string, unknown>;
}

@Injectable({providedIn: 'root'})
export class ProjectDetailsDraftService {
    private static readonly KEY_PREFIX = 'project-details-draft.';

    // localStorage, not sessionStorage: this draft must survive the browser tab
    // being closed (PRM-157), not just an in-app navigation.
    private localStorageService = inject(LocalStorageService);

    public save(projectId: number, draft: IProjectDetailsDraft): void {
        this.localStorageService.store(this.key(projectId), draft);
    }

    public load(projectId: number): IProjectDetailsDraft | null {
        const draft = this.localStorageService.retrieve(this.key(projectId));

        return this.isDraft(draft) ? draft : null;
    }

    public clear(projectId: number): void {
        this.localStorageService.clear(this.key(projectId));
    }

    private key(projectId: number): string {
        return `${ProjectDetailsDraftService.KEY_PREFIX}${projectId}`;
    }

    private isDraft(value: unknown): value is IProjectDetailsDraft {
        return !!value && typeof value === 'object' && !Array.isArray(value);
    }
}
